<div class="row fields-group">
    <div class="col">
        <label class="ui-checkbox input-label">
            <input class="form-control" name="isDistinct" type="checkbox"
                 value="{{isDistinct}}"
                 (change)="typeUpdate('distinct')"
                 [(ngModel)]="isDistinct">
            <span>{{ "Use distinct By" | translate }}</span>
        </label>
    </div>
    <div class="col">
        <label class="ui-checkbox input-label">
            <input class="form-control" name="isGroupBy" type="checkbox"
                 value="{{isGroupBy}}"
                 (change)="typeUpdate('groupBy')"
                 [(ngModel)]="isGroupBy">
            <span>{{ "Use group By" | translate }}</span>
        </label>
    </div>
</div>


<!--<h3>{{ 'dataTransformations.searchTransformations' | translate }}</h3>-->
<div class="row fields-group" *ngIf="(isDistinct || isGroupBy) && gridItems.length">
    <div class="col">
        <label *ngIf="isDistinct" for="search-transformation-field" class="d-block list-title">{{ "Field to distinct by" | translate }}</label>
        <label *ngIf="isGroupBy" for="search-transformation-field" class="d-block list-title">{{ "Field to group by" | translate }}</label>
        <select id="search-transformation-field" class="d-flex w-100 form-control" [(ngModel)]="typeTransformation" (change)="fieldUpdate()">
            <option value="null">{{'Select' | translate}}</option>
            <!--<option value="trimData">{{'Trim data' | translate}}</option>-->
            <option *ngFor="let f of gridItems" value="{{f.fullKey}}">{{f.name | translate}}</option>
        </select>
        <i *ngIf="isDistinct" class="form-text text-muted">{{"Please make sure to map the selected field" | translate}}</i>
        <i *ngIf="isGroupBy" class="form-text text-muted">{{"Please make sure to map numeric fields inside the grids and set a group function" | translate}}</i>
    </div>
</div>
